import {Typography} from "@mui/material";

export const ExchangeInfoContent = () => {


    return {
        title: 'Exchange Rates',
        content: (
            <>
                <Typography paragraph>
                    Exchange Rates provide the currency conversion data
                    used throughout the system.
                </Typography>

                <ul>
                    <li>
                        Each Exchange Rate defines the conversion rate
                        between one currency and another on a specific date.
                    </li>

                    <li>
                        Exchange Rates are used to convert financial values
                        from one currency into another during calculations,
                        reporting, and analysis.
                    </li>

                    <li>
                        Use the <strong>Search</strong> (magnifying glass)
                        to locate existing Exchange Rates.
                    </li>

                    <li>
                        Use the <strong>Upload</strong> button to load
                        Exchange Rate data from a file.
                    </li>

                    <li>
                        Use the <strong>Add</strong> (+) button to create
                        a new Exchange Rate manually.
                    </li>

                    <li>
                        Use the row menu on the left side of the grid
                        to clone, edit, or delete existing Exchange Rates.
                    </li>

                    <li>
                        Maintaining accurate Exchange Rates ensures
                        consistent currency conversions across all
                        contracts, obligations, and financial reports.
                    </li>
                </ul>
            </>
        )
    };

};

